import React, { ReactNode } from 'react';
import { Breadcrumbs } from 'components';
import { WppTypography, WppActionButton, WppIconChevron } from '@wppopen/components-library-react';
import { Main, MainText, MainTextWrapper, ChildrenWrapper } from './HeaderStyles';
import { useNavigate, useLocation } from 'react-router-dom';
import { Localization, TestIds } from 'utils';

export type columnDirectionType = 'column' | 'row';

interface IHeader {
    title?: string;
    children?: ReactNode;
    localization?: Localization;
    isBackButtonShown?: boolean;
    isBreadcrumbShown?: boolean;
    flexDirection?: columnDirectionType;
}

export const Header = ({
    title,
    children,
    localization = Localization.UK,
    isBackButtonShown = false,
    isBreadcrumbShown = false,
    flexDirection = 'row',
}: IHeader) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handlerNavigateHome = () => {
        const currentLocation = location.pathname;

        if (currentLocation.includes('create_scenario')) {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    return (
        <Main>
            <MainTextWrapper>
                {isBackButtonShown && (
                    <WppActionButton
                        onClick={handlerNavigateHome}
                        data-testid={TestIds.projection.actions.backButton}
                    >
                        <WppIconChevron slot="icon-start" direction="left" />
                        Back
                    </WppActionButton>
                )}
                {isBreadcrumbShown && <Breadcrumbs localization={localization} />}
                <MainText>
                    <WppTypography
                        tag="h1"
                        type="3xl-heading"
                        data-testid={TestIds.projection.header.title}
                    >
                        {title}
                    </WppTypography>
                </MainText>
            </MainTextWrapper>
            <ChildrenWrapper flexDirection={flexDirection}>{children}</ChildrenWrapper>
        </Main>
    );
};
